import React from 'react';

import { cn } from '../../../../../tailwind-base/utils';
import ProductCard from '../../../../tailwind/ProductCard';
import { DeptGrid } from '@repo/ui-components/dept/design-system';
import { generateSectionId } from '@repo/ui-components/dept/utils/generateSectionId';
import MarketingCalloutCard from '../../../../tailwind/MarketingCalloutCard';
import CTAButton from '../../../../tailwind/CTAButton';
import { SanityDeptCta } from '../../../../../models/gatsby-graphql-types';

interface Props {
  block: {
    products: any[];
    title: string;
    cta: SanityDeptCta;
    lightVersion: boolean;
    marketingCallout: {
      title: string;
      position: number;
      background: {
        asset: {
          url: string;
        };
      };
      cta: SanityDeptCta;
    };
  };
}
const GridProductCallout = ({ block }: Readonly<Props>) => {
  const { products, title, cta, marketingCallout, lightVersion } = block;

  const productsList = products;
  if (
    marketingCallout &&
    !productsList?.some(el => el._type === 'deptMarketingCallout')
  ) {
    const { background } = marketingCallout;
    if (background?.asset?.url) {
      productsList
        ?.splice((marketingCallout?.position ?? 5) - 1, 0, marketingCallout)
        ?.slice(0, 7);
    }
  }

  const ctaDisabled = !/disable/i.test(cta?.link?.linkType);

  return (
    <section
      {...generateSectionId(block)}
      className={lightVersion ? 'bg-muted' : 'bg-foreground'}
    >
      <div className="py-14 mx-auto max-w-screen-2xl lg:py-20">
        <div className="relative z-[1]">
          <div className="flex justify-between mb-16 flex-wrap gap-6">
            <h2
              className={cn(
                'font-black',
                lightVersion ? 'text-foreground' : 'text-secondary-foreground'
              )}
            >
              {title}
            </h2>
            {!ctaDisabled && <CTAButton cta={cta} />}
          </div>
          <DeptGrid rowGap={{ base: 20, md: 10, lg: 20 }}>
            {productsList?.map(product => (
              <div
                className="col-span-6 md:col-span-3 lg:col-span-4 xl:col-span-3"
                key={product._id || product.title}
              >
                {product._id ? (
                  <ProductCard product={product} />
                ) : (
                  <MarketingCalloutCard
                    heading={product?.title}
                    image={product?.background}
                    cta={product?.cta}
                  />
                )}
              </div>
            ))}
          </DeptGrid>
        </div>
      </div>
    </section>
  );
};

export default GridProductCallout;
